<div class="position-relative">
  <a
    href="javascript:;"
    class="sidebar-toggle-btn"
    [matTooltip]="isSelectorSidebarOpen ? 'Collapse the sidebar.' : 'Expand the sidebar.'"
    matTooltipPosition="right"
    (click)="onToggleSidebar()"
  >
    <i class="far fa-arrow-right" *ngIf="!isSelectorSidebarOpen"></i>
    <i class="far fa-arrow-left" *ngIf="isSelectorSidebarOpen"></i>
  </a>

  <div class="tokens-sidebar-wrapper">
    <div class="mt-3 mx-4 mb-4" *ngIf="showStep">
      <div class="text-semi-bold">
        <span class="badge badge-circle badge-light border text-md">4</span>
        <ng-container *ngIf="isOnetime" i18n> Prepare the document for signing.</ng-container>
        <ng-container *ngIf="!isOnetime" i18n> Prepare the template for signing.</ng-container>
      </div>
    </div>

    <app-template-fields-selector
      [templateType]="templateType"
      [isOnetime]="isOnetime"
      [form]="form"
      [roleColors]="roleColors"
      [selectedField]="defaultFieldElm"
      (selectField)="onSelectedSignFieldChange($event)"
      (role)="currentRole = $event"
    ></app-template-fields-selector>
  </div>
</div>
<div class="template-wrapper">
  <app-template-fields-editor
    class="doc-holder w-100"
    #editor
    [templateType]="templateType"
    [templateFileUrl]="templateFileUrl"
    [fields]="fields"
    [font]="font"
    [fontSize]="fontSize"
    [roleColors]="roleColors"
    [currentRole]="currentRole"
    [defaultField]="defaultSignFieldData"
  ></app-template-fields-editor>
</div>
